import { Extension } from "@tiptap/core";

/**
 * Tamanho de fonte via mark `textStyle` (compatível com Color / FontFamily do TipTap v2).
 */
export const FontSize = Extension.create({
  name: "fontSize",
  addGlobalAttributes() {
    return [
      {
        types: ["textStyle"],
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (el) => el.style.fontSize?.replace(/['"]+/g, "") || null,
            renderHTML: (attrs) => {
              if (!attrs.fontSize) return {};
              return { style: `font-size: ${attrs.fontSize}` };
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      setFontSize:
        (fontSize) =>
        ({ chain }) => {
          if (!fontSize) {
            return chain().focus().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run();
          }
          return chain().focus().setMark("textStyle", { fontSize }).run();
        },
      unsetFontSize:
        () =>
        ({ chain }) =>
          chain().focus().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run(),
    };
  },
});
